import { isAfter, parse, subMonths } from 'date-fns';
import * as yup from 'yup';

const youngestPup = subMonths(new Date(), 3);

export const schema = yup.object({
  year: yup
    .string()
    .required(`Your pup's year of birth is required`)
    .notOneOf(['0'], `Your pup's year of birth is required`),
  month: yup
    .string()
    .required(`Your pup's month of birth is required`)
    .notOneOf(['0'], `Your pup's month of birth is required`)
    .test(
      'is-not-too-young',
      'Sorry, we cannot accept pups less than 3mo old.',
      (month, { parent }) => {
        if (parent.month) {
          const date = parse(
            `${parent.year}-${month}-${parent.day || '01'}`,
            'yyyy-MM-dd',
            new Date(),
          );
          return isAfter(youngestPup, date);
        }
        return true;
      },
    ),
  day: yup.string(),
});

export const optionalSchema = yup.object({
  year: yup.string(),
  month: yup
    .string()
    .test(
      'is-not-too-young',
      'Sorry, we cannot accept pups less than 3mo old.',
      (month, { parent }) => {
        if (parent.month) {
          const date = parse(
            `${parent.year}-${month}-${parent.day || '01'}`,
            'yyyy-MM-dd',
            new Date(),
          );
          return isAfter(youngestPup, date);
        }
        return true;
      },
    ),
  day: yup.string(),
});
